export default {};



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/resources/SHS-SPRINT/index.ts